import { useAppSelector } from 'app/hooks';
import { isServiceAvailable } from 'utils';
import {
  selectEntitlements,
  selectIsUserAgent,
  selectUserFeatures,
} from 'services/session/sessionSelectors';
import type { ServicesType } from 'utils/globalTypes';

function useIsFeatureAvailable(
  service: ServicesType | string[],
  agentCheckRequired = true,
) {
  const userFeatures = useAppSelector(selectUserFeatures);
  const isAgent = useAppSelector(selectIsUserAgent);
  const rawEntitlements = useAppSelector(selectEntitlements);

  return isServiceAvailable(
    service,
    { userFeatures, isAgent, rawEntitlements },
    agentCheckRequired,
  );
}

export default useIsFeatureAvailable;
